import { get, post } from "src/services/api";

const EARCON_TYPES_ENDPOINT = "/assistants/earcon-types";
const PREVIEW_EARCON_ENDPOINT = "/assistants/preview-earcon";

export const fetchEarconTypes = async () => await get({
  endpoint: EARCON_TYPES_ENDPOINT
});

export const previewEarcon = async ({ earconType, earconVolume }) => {
  const payload = {
    earconType,
    earconVolume
  };

  const response = await post({ endpoint: PREVIEW_EARCON_ENDPOINT, data: payload, responseType: "arraybuffer" });
  const audioBlob = new Blob([response], { type: "audio/wav" });
  return audioBlob;
};
